export default {
  methods: {
    nombreIncluyeTeens(texto) {
      return String(texto || '').toUpperCase().indexOf('TEENS') !== -1
    },

    alumnoVieneDeCursoTeens() {
      if (!this.alumno) return false
      if (this.nombreIncluyeTeens(this.alumno.curso)) return true

      const ids = []
      if (this.alumno.id_curso_actual) ids.push(this.alumno.id_curso_actual)
      if (this.alumno.id_curso) ids.push(this.alumno.id_curso)

      const precios = this.precios || []
      for (let i = 0; i < ids.length; i++) {
        const curso = precios.find(el => el.id_curso == ids[i])
        if (curso && this.nombreIncluyeTeens(curso.curso)) return true
      }

      return false
    },

    usarTarifaTeensEnCambio(grupoNombre) {
      return this.nombreIncluyeTeens(grupoNombre) || this.alumnoVieneDeCursoTeens()
    },

    paramsRecalculoConsecutivos() {
      const idCurso = this.precioSeleccionado2 != null
        ? this.precioSeleccionado2
        : this.precioSeleccionado

      const idGrupoActual = this.alumno && this.alumno.id_grupo_actual
        ? this.alumno.id_grupo_actual
        : (this.grupoAnterior && this.grupoAnterior.id_grupo)

      const aplicaIva = !!(this.alumno && this.alumno.iva) ||
        !!(this.grupoAnterior && this.grupoAnterior.iva)

      return {
        id_curso: idCurso,
        id_grupo_actual: idGrupoActual,
        aplica_iva: aplicaIva,
      }
    },

    referenciaSaldoFila(fila) {
      if (fila.precio_nuevo_grupo != null && fila.precio_nuevo_grupo !== '') {
        return Number(fila.precio_nuevo_grupo)
      }
      return Number(this.total_a_pagar) || 0
    },

    recalcularSaldosConsecutivos() {
      for (const i in this.gruposConsecutivos) {
        const pagado = Number(this.gruposConsecutivos[i].pagado) || 0
        const referencia = this.referenciaSaldoFila(this.gruposConsecutivos[i])
        this.$set(
          this.gruposConsecutivos[i],
          'saldo',
          (pagado - referencia).toFixed(2)
        )
      }
    },

    gruposDisponiblesConsecutivo(item) {
      const fuente = (this.gruposDisponibles && this.gruposDisponibles.length)
        ? this.gruposDisponibles
        : this.grupos
      if (!fuente || !fuente.length) return []
      const idCicloRow = Number(item.id_ciclo) || 0
      return fuente.filter((g) => Number(g.id_ciclo) >= idCicloRow)
    },

    puedeSeleccionarGrupoConsecutivo() {
      const fuente = (this.gruposDisponibles && this.gruposDisponibles.length)
        ? this.gruposDisponibles
        : this.grupos
      return fuente && fuente.length > 0
    },

    grupoConsecutivoSeleccionado(item) {
      if (!item.nuevo_id_grupo) return null

      const idNuevo = Number(item.nuevo_id_grupo)

      if (this.grupos && this.grupos.length) {
        const encontrado = this.grupos.find((g) => Number(g.id_grupo) === idNuevo)
        if (encontrado) return encontrado
      }

      return {
        id_grupo: idNuevo,
        grupo: item.nuevo_grupo,
        id_ciclo: item.nuedo_id_ciclo,
      }
    },

    aplicarGrupoConsecutivoLocal(item, grupo) {
      const indice = this.gruposConsecutivos.indexOf(item)
      if (indice < 0) return

      if (grupo && grupo.id_grupo) {
        this.$set(this.gruposConsecutivos[indice], 'nuevo_grupo', grupo.grupo)
        this.$set(this.gruposConsecutivos[indice], 'nuevo_id_grupo', grupo.id_grupo)
        this.$set(this.gruposConsecutivos[indice], 'nuedo_id_ciclo', grupo.id_ciclo)
      } else {
        this.$set(this.gruposConsecutivos[indice], 'nuevo_grupo', '')
        this.$set(this.gruposConsecutivos[indice], 'nuevo_id_grupo', '')
        this.$set(this.gruposConsecutivos[indice], 'nuedo_id_ciclo', '')
        this.$set(this.gruposConsecutivos[indice], 'precio_nuevo_grupo', null)
      }
    },

    async onGrupoConsecutivoChange(item, grupo) {
      const indice = this.gruposConsecutivos.indexOf(item)
      if (indice < 0) return

      this.aplicarGrupoConsecutivoLocal(item, grupo)
      this.cargar = true

      try {
        const { data } = await this.$http.post('grupos.consecutivos.seleccion', {
          id_alumno: this.alumno.id_alumno,
          indice,
          grupoSeleccionado: grupo || null,
          gruposConsecutivos: this.gruposConsecutivos,
          total_a_pagar: this.total_a_pagar,
          ...this.paramsRecalculoConsecutivos(),
        })
        this.aplicarSaldosConsecutivosDesdeApi(data)
      } catch (error) {
        const status = error.response && error.response.status
        if (status === 404) {
          await this.recalcularPrecioFilaConsecutivo(item, grupo)
          this.recalcularSaldosConsecutivos()
          return
        }

        const mensaje = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'No fue posible actualizar el grupo consecutivo'
        this.validarError(mensaje)
      } finally {
        this.cargar = false
      }
    },

    async recalcularPrecioFilaConsecutivo(item, grupo) {
      if (!grupo || !grupo.id_grupo) return

      const indice = this.gruposConsecutivos.indexOf(item)
      if (indice < 0) return

      const idCurso = this.paramsRecalculoConsecutivos().id_curso
      if (!idCurso) return

      const payload = {
        id_alumno: this.alumno.id_alumno,
        id_grupo: this.alumno.id_grupo_actual || (this.grupoAnterior && this.grupoAnterior.id_grupo),
        escuela: String(grupo.grupo || '').includes('FAST') ? 2 : 1,
        id_curso: idCurso,
        id_ciclo: grupo.id_ciclo,
        idhermanos: this.alumno.idhermanos,
        alumno_ni: false,
      }

      const { data } = await this.$http.post('pago.grupo.nuevo.descuento', payload)
      let precio = Number(data[0].precio_lista) || 0

      if (this.alumno && this.alumno.iva) {
        precio = Number((precio * 1.16).toFixed(2))
      } else if (this.grupoAnterior && this.grupoAnterior.iva) {
        precio = Number((precio * 1.16).toFixed(2))
      }

      this.$set(this.gruposConsecutivos[indice], 'precio_nuevo_grupo', precio)
    },

    aplicarSaldosConsecutivosDesdeApi(data) {
      this.gruposConsecutivos = data.map((fila) => ({ ...fila }))
      this.recalcularSaldosConsecutivos()
    },
  },
}
